(function () {
  'use strict';
  if (window.__hnnTerms) return;
  window.__hnnTerms = true;

  var CONTRACT_URL = '/pages/mesafeli-satis-sozlesmesi';
  var KVKK_URL = '/pages/kvkk-aydinlatma-metni';
  var STORAGE_KEY = 'hnnTermsAccepted';
  var ATTR_NAME = 'Mesafeli Satış Sözleşmesi Onayı';

  var css = '' +
    '.hnn-terms{margin:0 0 1.4rem;text-align:left;font-size:1.3rem;line-height:1.5;color:rgba(var(--color-foreground),.85)}' +
    '.hnn-terms__label{display:flex;align-items:flex-start;gap:.8rem;cursor:pointer}' +
    '.hnn-terms__input{flex:0 0 auto;width:1.8rem;height:1.8rem;margin:.1rem 0 0;accent-color:#121212;cursor:pointer}' +
    '.hnn-terms a{color:inherit;text-decoration:underline;text-underline-offset:.2rem}' +
    '.hnn-terms__error{margin:.6rem 0 0;color:#b3261e;font-size:1.25rem}' +
    '.hnn-terms__error[hidden]{display:none}' +
    '.hnn-terms--error .hnn-terms__input{outline:2px solid #b3261e;outline-offset:2px}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  function isAccepted() {
    try { return sessionStorage.getItem(STORAGE_KEY) === '1'; } catch (e) { return false; }
  }
  function remember(on) {
    try {
      if (on) { sessionStorage.setItem(STORAGE_KEY, '1'); } else { sessionStorage.removeItem(STORAGE_KEY); }
    } catch (e) {}
  }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function stamp() {
    var d = new Date();
    return 'Onaylandı - ' + pad(d.getDate()) + '.' + pad(d.getMonth() + 1) + '.' + d.getFullYear() + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes());
  }
  function saveAttribute(value) {
    var attrs = {};
    attrs[ATTR_NAME] = value;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (r) { return r.ok; }).catch(function () { return false; });
  }

  function setAllChecked(on) {
    var inputs = document.querySelectorAll('.hnn-terms__input');
    for (var i = 0; i < inputs.length; i++) { inputs[i].checked = on; }
  }
  function hideErrors() {
    var boxes = document.querySelectorAll('.hnn-terms');
    for (var i = 0; i < boxes.length; i++) {
      boxes[i].classList.remove('hnn-terms--error');
      var p = boxes[i].querySelector('.hnn-terms__error');
      if (p) { p.hidden = true; }
    }
  }
  function showError() {
    var boxes = document.querySelectorAll('.hnn-terms');
    var firstVisible = null;
    for (var i = 0; i < boxes.length; i++) {
      boxes[i].classList.add('hnn-terms--error');
      var p = boxes[i].querySelector('.hnn-terms__error');
      if (p) { p.hidden = false; }
      if (!firstVisible && boxes[i].offsetParent !== null) { firstVisible = boxes[i]; }
    }
    if (firstVisible && firstVisible.scrollIntoView) {
      firstVisible.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function buildBox() {
    var wrap = document.createElement('div');
    wrap.className = 'hnn-terms';
    var id = 'hnn-terms-' + Math.random().toString(36).slice(2, 8);
    wrap.innerHTML =
      '<label class="hnn-terms__label" for="' + id + '">' +
      '<input type="checkbox" class="hnn-terms__input" id="' + id + '">' +
      '<span><a href="' + CONTRACT_URL + '" target="_blank" rel="noopener">Mesafeli Satış Sözleşmesi</a>\'ni ve ' +
      '<a href="' + KVKK_URL + '" target="_blank" rel="noopener">KVKK Aydınlatma Metni</a>\'ni okudum, kabul ediyorum.</span>' +
      '</label>' +
      '<p class="hnn-terms__error" role="alert" hidden>Ödemeye geçmek için sözleşmeyi onaylamanız gerekir.</p>';
    var input = wrap.querySelector('input');
    input.checked = isAccepted();
    input.addEventListener('change', function () {
      var on = input.checked;
      remember(on);
      setAllChecked(on);
      hideErrors();
      saveAttribute(on ? stamp() : '');
    });
    return wrap;
  }

  function inject() {
    var buttons = document.querySelectorAll('button[name="checkout"]');
    for (var i = 0; i < buttons.length; i++) {
      var anchor = buttons[i].closest('.cart__ctas') || buttons[i];
      var parent = anchor.parentNode;
      if (!parent) { continue; }
      var prev = anchor.previousElementSibling;
      if (prev && prev.classList && prev.classList.contains('hnn-terms')) { continue; }
      parent.insertBefore(buildBox(), anchor);
    }
  }

  function guard(e) {
    var target = e.target;
    if (!target || !target.closest) { return; }
    var el = target.closest('button[name="checkout"], a[href="/checkout"], a[href^="/checkout?"]');
    if (!el) { return; }
    if (el.dataset.hnnOk === '1') { delete el.dataset.hnnOk; return; }
    e.preventDefault();
    e.stopImmediatePropagation();
    if (!isAccepted()) { showError(); return; }
    saveAttribute(stamp()).then(function () {
      el.dataset.hnnOk = '1';
      el.click();
    });
  }
  document.addEventListener('click', guard, true);

  document.addEventListener('submit', function (e) {
    var s = e.submitter;
    if (s && s.name === 'checkout' && s.dataset.hnnOk !== '1' && !isAccepted()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showError();
    }
  }, true);

  var timer;
  var observer = new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(inject, 60);
  });
  observer.observe(document.body, { childList: true, subtree: true });
  inject();
})();
